import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { postReactNativeMessage } from '../../libs/reactNativeBridge'

export default function PostReactNativeMessage({ authenticated }) {
  const location = useLocation()
  useEffect(() => {
    postReactNativeMessage()
  }, [authenticated, location])
  return null
}
